@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  position: fixed;
  bottom: 60px;
  right: 0;
  width: 237px;
  border-radius: 10px;
  padding: 15px;
  background: linear-gradient(127.51deg, #9500ff 25.74%, #6a00ff 97.82%);
  z-index: 9999;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > div {
      display: flex;
      align-items: center;
    }

    .stepsCompleted {
      @include xs-sohne-book;
      color: var(--light-80);
      margin-right: 16px;
    }

    .progressBar {
      flex-shrink: 0;
      width: 67px;
    }

    .close {
      button {
        width: 28px;

        & > span {
          padding: 0;
        }
      }
    }
  }

  .title {
    @include xl-sohne;
    font-size: 22px;
    margin-top: 20px;
    color: #fcfcff;
  }

  .content {
    @include sm-sohne;
    margin-top: 15px;
    color: var(--light-100);
  }

  .footer {
    display: flex;
    margin-top: 20px;
    width: 100%;

    button {
      &:hover,
      &:focus {
        background: var(--light-80);
      }
    }
  }
}
